import { Notifications } from "./shared/notifications.model";
import { Notification } from "./shared/notification.model";
import { Injectable } from "@angular/core";

@Injectable()
export class NotificationService {
  private notifications: Notifications = new Notifications();

  private loader: any = {
    text: "Carregando...",
    status: false
  };

  add(notification: Notification) {
    this.notifications.add(notification);
  }

  getNotification(): Notifications {
    return this.notifications;
  }

  getLoader() {
    return this.loader;
  }

  success(text: string) {
    this.add({
      text: text,
      icon: "check",
      cssClass: "bg-success"
    });
  }

  error(text: string) {
    this.add({
      text: text,
      icon: "error",
      cssClass: "bg-danger"
    });
  }

  info(text: string) {
    this.add({
      text: text,
      icon: "info",
      cssClass: "bg-primary"
    });
  }

  warning(text: string) {
    this.add({
      text: text,
      icon: "warning",
      cssClass: "bg-warning"
    });
  }

  load(status: boolean, text?: string) {
    text !== undefined ? (this.loader = text) : "Carregando...";
    this.loader.status = status;
  }

  constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/notification/notification.service.ts